import { EVENT_HUB_URL_TEXT } from '../../../event-hubs.text';
import { trimSpaces } from '../../../../../modules/formatters';
import { FormVmItemConfigType } from '../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../infrastructure/utils/form-config.utils';
import { subdomainValidator } from '../../../../../modules/validators';


export enum EventHubSubdomainFormField {
    SUBDOMAIN = 'subdomain',
}

export const FORM_CONFIG = {
    [EventHubSubdomainFormField.SUBDOMAIN]: {
        labelDescriptor: EVENT_HUB_URL_TEXT,
        defaultValue: '',
        formatters: [trimSpaces],
        validators: [subdomainValidator]
    }
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);